<template lang="pug">
  y-dialog(v-model="showModal" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="610" persistent scrollable content-class="round-3xl")
    v-card
      v-card-title.pa-4
        v-row(no-gutters align="center")
          v-col(cols="10" offset="1")
            div.text-xl.font-bold.neutral700--text.text-center {{ $t('edit_message') }}
          v-col(cols="1" align="right")
            v-btn.ml-n3(text icon @click="showModal = false")
              v-icon(color="neutral700" :size="24") mdi-close
      v-divider.basic300
      v-card-text.pt-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
        div.d-flex.justify-center.mt-16(v-if="isFetching")
          v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
        v-form(v-else ref="extraform")
          div.text-md.font-semibold.neutral700--text.mt-3 {{ $t('message_template') }}
          //- v-textarea.mt-4(ref="textarea" v-model='finalMessage' background-color="basic200" :placeholder="$t('message.placeholder')" hide-details outlined dense @input="updateCursor" @change="updateCursor" @focus="updateCursor" auto-grow)
          v-textarea.text-sm.mt-3.round-xl(ref="textarea" v-model='finalMessage' :placeholder="$t('current_template_placeholder')" outlined hide-details="auto" @input="updateCursor" @change="updateCursor" @focus="updateCursor" auto-grow)
          .guide.mt-4.text-xs.neutral500--text
            div {{ $t('tips_to_format') }}: 
              div.ml-2 1. 
                span(style="font-style: italic") Italic: 
                b  _text_
              div.ml-2 2. 
                span(style="font-weight: bold") Bold: 
                b  *text*
              div.ml-2 3. 
                span(style="text-decoration: line-through") Strikethrough
                b : ~text~
              div.ml-2 4. 
                span(style="font-family: 'Courier New', Courier, monospace") Monospace: 
                b  ```text```
            div.caption
              span {{ $t('source') }}:
              a.text-decoration-none.textColorAccent--text.ml-2(href="https://faq.whatsapp.com/general/chats/how-to-format-your-messages" target="_blank") WhatsApp
          div.mt-4.text-sm.font-medium.neutral700--text {{ $t('insert_field') }}: 
          div.mt-2.text-sm.neutral500--text {{ $t('you_can_insert_field_into') }}: 
          .field-type
            v-layout.mt-2.mx-n1
              v-item-group
                v-item.mb-2
                  v-btn.button-xs.round-3xl.mx-1(color="neutral700" small outlined @click="insertValue('name')") {{ $t('name') }}
                v-item.mb-2
                  v-btn.button-xs.round-3xl.mx-1(color="neutral700" small outlined @click="insertValue('doctor')") {{ $t('doctor') }}
                v-item.mb-2
                  v-btn.button-xs.round-3xl.mx-1(color="neutral700" small outlined @click="insertValue('service')") {{ $t('service') }}
                v-item.mb-2
                  v-btn.button-xs.round-3xl.mx-1(color="neutral700" small outlined @click="insertValue('date')") {{ $t('date') }}
                v-item.mb-2
                  v-btn.button-xs.round-3xl.mx-1(color="neutral700" small outlined @click="insertValue('time')") {{ $t('time') }}
                v-item.mb-2
                  v-btn.button-xs.round-3xl.mx-1(color="neutral700" small outlined @click="insertValue('appointment_link')") {{ $t('appointment_link') }}
                v-item.mb-2
                  v-btn.button-xs.round-3xl.mx-1(color="neutral700" small outlined @click="insertValue('pre_appt_instruction')") {{ $t('pre_appointment_instruction') }}
                v-item.mb-2
                  v-btn.button-xs.round-3xl.mx-1(color="neutral700" small outlined @click="insertValue('post_appt_instruction')") {{ $t('post_appointment_instruction') }}
          .live-view.my-4(v-if="finalMessage")
            v-card.pa-4(outlined)
              div.s1.basic1000--text.mb-4 {{ $t('message_preview') }}:
              div(class="message" v-html="formatInput(formattedMessage)")

      v-divider
      v-card-actions.py-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
        v-btn.button-md.neutral700--text.px-0(@click="showModal = false" text) {{ $t('cancel') }}
        v-spacer
        v-btn.button-md(color="neutral700" depressed dark :loading="isLoading" @click="updateTemplate") {{ $t('save') }}
</template>

<script>
export default {
  name: 'EditMessageTemplate',
  props: ['open', 'templateMessage'],
  data: () => ({
    isLoading: false,
    isFetching: false,
    finalMessage: '',
    cursorPosition: 0
  }),
  mounted () {
    if (this.templateMessage) {
      this.finalMessage = this.templateMessage
    }
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    formattedMessage () {
      if (this.finalMessage) {
        let message = this.finalMessage
        message = message.split('{{name}}').join('Sarah Danial')
        message = message.split('{{doctor}}').join('Dr Jamal')
        message = message.split('{{service}}').join('General Consultation')
        message = message.split('{{date}}').join('12 Jan 2023')
        message = message.split('{{time}}').join('01.30 PM')
        message = message.split('{{appointment_link}}').join('https://clinic.yezza.co/appointment/101')      
        message = message.split('{{pre_appt_instruction}}').join('1. Drink water and do not urinate before your ultrasound scan. Having water in your bladder will help the Sonographer to see your baby more clearly. \n2. We recommend a two-piece outfit so we can access your abdomen without you removing your clothing.')      
        message = message.split('{{post_appt_instruction}}').join('1. Get plenty of rest as much as possible to cope with tiredness and fatigue. \n2. Avoid raw or undercooked foods in your daily meal.')  
        return message
      }
      return this.finalMessage
    },
    textarea () {
      return this.$refs.textarea.$el.querySelector('textarea')
    }
  },
  methods: {
    updateCursor () {
      const postion = this.textarea.selectionStart
      if (!postion) {
        setTimeout(() => {
          this.cursorPosition = this.textarea.selectionStart
        }, 500)
      } else {
        this.cursorPosition = this.textarea.selectionStart
      }
    },
    insertValue (value) {
      this.finalMessage = `${this.finalMessage.substring(0, this.cursorPosition)}{{${value}}}${this.finalMessage.substring(this.cursorPosition, this.finalMessage.length)}`
    },
    updateTemplate() {
      if (!this.$refs.extraform.validate()) {
        return
      }
      this.isLoading = true
      this.$emit('saving', this.finalMessage)
    },
    formatInput(string) {
      string = String(string);
      
      //-----> for bold text
      let bold = string.split(" ").map((word) =>
      {
        if (/\*/.test(word) && !/^\**$/.test(word))
          if (/(^(~\*)|^(_\*)|^\*)(.*)(\*$|(\*_)$|(\*\W)$)/.test(word))
            return word.replace(/\*([^\r\n]+)\*/g, "<b>$1</b>")
          else if (/[_*~]\*(.*)\*[~*_]/.test(word))
            return word.replace(/\*([^*][^\r\n]+[^*])\*/g, "<b>$1</b>");
        return word;
      }).join(" ");

      //-----> for italic text 
      let italic = bold.split(" ").map((word) =>
      {
        if (/_/.test(word) && !/^_+$/.test(word))
        if (/(^~_|^_<.*>|^_\*|^_)(.*)(_$|(_<.*>)$|(_\*)$|(_\W)$)/.test(word))
          return word.replace(/_([^\r\n]+)_/g, "<i>$1</i>");
        else if (/(~|_|\*|<.*>)_(.*)_(<.*>|\*|~|_)/.test(word))
          return word.replace(/_([^_][^\r\n]+[^_])_/g, "<i>$1</i>");
        return word;
      }).join(" ");
      
      //----->for strikethrough/deleted text 
      let strikethrough = italic.split(" ").map((word) =>
      {
        if (/~/.test(word) && !/^~+$/.test(word))
          if (/(^_~|^~<.*>|^\*~|^~)(.*)(~$|(~_)$|(~<.*>)$|(~\*)$|(~\W)$)/.test(word))
            return word.replace(/~([^\r\n]+)~/g, "<del>$1</del>")
          else if (/(~|_|\*|<.*>)~(.*)~(<.*>|\*|~|_)/.test(word))
            return word.replace(/~([^~][^\r\n]+[^~])~/g, "<del>$1</del>");
        return word;
      }).join(" ");
      
      
      
      //-----> for underlined text
      var underline = strikethrough.split(" ").map(function(word)
      {
        if (/%/.test(word) && !/^%+$/.test(word))
          if (/(^_%|^~%|^%<.*>|^\*%|^%)(.*)(%$|(%~)$|(%_)$|(%<.*>)$|(%\*)$|%\W+$)/.test(word))
            return word.replace(/%([^\r\n]+)%/g, "<u>$1</u>")
          else if (/(%|~|_|\*|<.*>)%(.*)%(<.*>|\*|~|%|_)/.test(word))
            return word.replace(/%([^%][^\r\n]+[^%])%/g, "<u>$1</u>");
        return word;
      }).join(" ");
      
      
      
      //-----> for monospace text
      var monospace = underline.split(" ").map(function(word)
      {
        if (/```/.test(word))
          if (/```(.|\n|\r)*(.+)(.|\n|\r])*```/.test(word)) 
            return word.replace(/```((.|\n|\r)*(.*)(\r|\n|.)*)```/g, `<span style="font-family: 'Courier New', Courier, monospace">$1</span>`);
        return word;
      }).join(" ");
        
      var formatted = monospace;
      
      //-----> for bold sentence formatting
      if (/\*(.*)\*/.test(formatted))
        formatted = formatted.replace(/(^|[\s_>~%`])\*([^\s\r\n]+[^*\n\r]+[^\s\r\n]+)\*([\W_\r\n\s]|$)/g, "$1<b>$2</b>$3");


      //-----> for italic sentence formatting 
      if (/_(.*)_/.test(formatted))
        formatted = formatted.replace(/(^|[\s>~%`*])_([^\s\r\n]+[^_\n\r]+[^\s\n\r]+)_([\W_\s\r\n]|$)/g, "$1<i>$2</i>$3");
      
      
      //-----> for strikethrough sentence formatting 
      if (/~(.*)~/.test(formatted))
        formatted = formatted.replace(/(^|[\s>%`*_])~([^\s\r\n]+[^~\r\n]+[^\r\n\s]+)~([\W_\s\r\n]|$)/g, "$1<del>$2</del>$3");
      
      
      //-----> for underline sentence formatting 
      if (/%(.*)%/.test(formatted))
        formatted = formatted.replace(/(^|[\s>~`*_])%([^\s\r\n]+[^%\r\n]+[^\r\n\s]+)%([\W_\s\r\n]|$)/g, "$1<u>$2</u>$3");
    
    
      //-----> for monospace sentence formatting
      var counter = 0;
      if (/```/.test(formatted))
      {
        var i = 0;
        formatted = formatted.split(" ");
        formatted = formatted.map(function(word)
        {
          //tempArr[i+1] handles case where input is like this: ``` ``` with no characters between back ticks
          if (!/<code>/.test(word))
            if (/```/.test(word) && formatted[i+1] != "```")
            {
              i++; counter++;
              if (counter % 2 != 0) 
                return word.replace("```", "<code>");
              else
                return word.replace("```", "</code>");
            } i++; 
          return word;
        }).join(" ");

        //handles case where there are no closing back ticks
        if (counter % 2 == 1)
        {
          formatted = formatted.split(" ");
          for (i = formatted.length-1; i >= 0; i--)
            if (/<code>/.test(formatted[i]))
            {
              formatted[i] = formatted[i].replace(/<code>/, "```");
              break;
            }
          formatted = formatted.join(" ");
        }
      }
      return formatted;
    }
  }
}
</script>

<style scoped>
.message {
  white-space: pre-wrap;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>
